export default __webpack_public_path__ + "media/images/favicon/android-chrome-36x36-3ee4b23fd72befd84aeba65f4b7e3a67.png";